import { trpc } from "@mnk/frontend/lib/trpc";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link, useNavigate } from "react-router-dom";

export const Header = () => {
  const navigate = useNavigate();

  const getUser = trpc.getUser.useQuery();
  const user = getUser.data;

  return (
    <header className="fixed top-0 left-0 right-0 flex items-center justify-between h-14 bg-gray-50 shadow-sm px-4 flex-shrink-0">
      <Link to="/" className="flex items-center gap-2">
        <img src="/logo.svg" alt="logo" className="h-6" />
        <p className="text-sm">図面旗揚げシステム</p>
      </Link>

      <div className="flex items-center gap-2">
        {user && (
          <p className="text-xs">
            {user.name}({user.email})
          </p>
        )}
        <SettingsIcon
          className="cursor-pointer text-gray-800"
          onClick={() => {
            navigate("/settings/account");
          }}
        />
      </div>
    </header>
  );
};
